import { useEffect, useRef, useState } from 'react';

const useTabulation = ({
  isActive,
  onTab = () => {},
  onEsc = () => {}
}: {
  isActive: boolean;
  onTab: () => void;
  onEsc: () => void;
}) => {
  const [focusedIndex, setFocusedIndex] = useState<number>(-1);

  const refArray = useRef<HTMLElement[]>([]);

  const enabledList = refArray.current.filter(value => value);

  useEffect(() => {
    const keyboardHandler = (event: KeyboardEvent) => {
      if (isActive) {
        if (event.key === 'Tab') {
          onTab();
        } else if (event.key === 'Enter' && focusedIndex !== -1) {
          if (enabledList[focusedIndex]) {
            enabledList[focusedIndex].click();
          }
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();

          setFocusedIndex(prevIndex => (prevIndex > 0 ? prevIndex - 1 : enabledList.length - 1));
        } else if (event.key === 'ArrowDown') {
          event.preventDefault();

          setFocusedIndex(prevIndex => (prevIndex < enabledList.length - 1 ? prevIndex + 1 : 0));
        } else if (event.key === 'Escape') {
          onEsc();
        }
      } else {
        setFocusedIndex(-1);
      }
    };

    window.addEventListener('keydown', keyboardHandler);

    return () => {
      window.removeEventListener('keydown', keyboardHandler);
    };
  }, [isActive, focusedIndex]);

  useEffect(() => {
    if (enabledList[focusedIndex]) {
      enabledList[focusedIndex].focus();
    }
  }, [focusedIndex]);

  return { focusedIndex, refArray };
};

export default useTabulation;
